<template>
  <div class="dashboard">
    <el-alert title="Welcome back to acquirer system" type="success" :closable="false"></el-alert>
    <el-row :gutter="10">
      <el-col :xs="24" :sm="24" :md="24" :lg="24">
        <el-card class="box-card">
          <div slot="header" class="clearfix">
            <span>Company</span>
          </div>
          <div>
            <table>
              <tr>
                <th>Company :</th>
                <td>{{ userData.companyname }}</td>
              </tr>
              <tr>
                <th>Member Code :</th>
                <td>{{ userData.membercode }}</td>
              </tr>
              <tr>
                <th>Username :</th>
                <td>{{ userData.fullname }}</td>
              </tr>
              <tr>
                <th>Email :</th>
                <td>{{ userData.email }}</td>
              </tr>
            </table>
          </div>
        </el-card>
      </el-col>
    </el-row>
    <el-row>
      <el-tag>Summary</el-tag>
      <summary-view :data="summaryData"></summary-view>
    </el-row>
    <el-row>
      <el-tag type="success">Summary Today</el-tag>
      <summary-view :data="summaryDataToday"></summary-view>
    </el-row>
  </div>
</template>

<script>
import user from "@/api/user";
import summary from "@/api/summary";
import summaryView from "@/components/summaryui/summary";
import utility from "@/components/utility";
export default {
  components: {
    summaryView
  },
  data() {
    return {
      userData: {
        companyname: "",
        membercode: "",
        user: ""
      },
      summaryData: {},
      summaryDataToday: {}
    };
  },
  methods: {
    getUser() {
      user.getUser().then(res => {
        if (res && res["result"]) {
          this.userData = res["data"];
          this.$store.state.user = res["data"];
        }
      });
    },
    getSummary() {
      summary.getSummary().then(res => {
        if (res && res["result"]) {
          this.summaryData = res["data"];
        }
      });

      const formData = {
        startdate: utility.currentDate('YYYY-MM-DD'),
        enddate: utility.currentDate('YYYY-MM-DD')
      };
      summary.getSummary(formData).then( res => {
         if (res && res["result"]) {
           this.summaryDataToday = res['data']
         }
      })
    }
  },
  created() {
    this.getUser();
    this.getSummary();
  }
};
</script>

<style lang="scss">
.dashboard {
  table {
    width: 100%;
    th {
      width: 50%;
      text-align: right;
      padding-right: 30px;
    }
  }
}
</style>